(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    // Mémoire locale : une fois inscrit ou une fois la fenêtre écartée, elle
    // ne se rouvre plus toute seule sur le panier. Les ouvertures explicites
    // — pied de page, panneau du compte — ne consultent jamais ce drapeau :
    // cliquer « Newsletter » doit toujours ouvrir la fenêtre.
    var SEEN = 'yumbei:newsletter-seen';

    function remember() {
      try { localStorage.setItem(SEEN, '1'); } catch (e) { /* navigation privée */ }
    }

    function alreadySeen() {
      try { return localStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
    }


    function init() {
      var dialog = document.querySelector('[data-newsletter-dialog]');
      if (!dialog || dialog.dataset.nlInit) return;
      dialog.dataset.nlInit = '1';

      // showModal() n'existe pas sur les très vieux navigateurs : sans lui, les
      // déclencheurs restent inertes plutôt que d'ouvrir une boîte non modale
      // impossible à fermer.
      var canOpen = typeof dialog.showModal === 'function';

      var titleDefault = dialog.querySelector('[data-nl-title-default]');
      var titleAccount = dialog.querySelector('[data-nl-title-account]');

      function open(variant, auto) {
        if (!canOpen || dialog.open) return;
        // Deux entrées, deux promesses. Le formulaire, lui, est le même.
        if (titleDefault && titleAccount) {
          var fromAccount = variant === 'account';
          titleDefault.hidden = fromAccount;
          titleAccount.hidden = !fromAccount;
        }
        // Le drapeau est posé à l'ouverture automatique, et non à la fermeture.
        // Il signifie « on te l'a déjà présentée toute seule », pas « tu l'as
        // fermée » : la fenêtre ne peut donc pas revenir à chaque passage sur le
        // panier si l'évènement de fermeture venait à manquer. Une ouverture
        // volontaire — pied de page, compte — ne le pose jamais.
        if (auto) remember();
        dialog.showModal();
      }

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-newsletter-open]');
        if (trigger) {
          event.preventDefault();
          open(trigger.dataset.newsletterOpen);
          return;
        }
        if (event.target.closest('[data-newsletter-close]')) {
          dialog.close();
        }
      });

      // Cliquer sur le voile ferme : l'élément <dialog> reçoit le clic quand il
      // tombe hors de sa propre boîte, ::backdrop n'étant pas une cible.
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });

      // Deuxième chemin vers le même drapeau, pour le cas où la fenêtre a été
      // ouverte volontairement puis fermée : inutile de la reproposer d'office
      // ensuite. L'ouverture automatique, elle, ne compte pas dessus.
      dialog.addEventListener('close', remember);

      // Le formulaire vient d'être envoyé avec succès : Shopify a renvoyé sur
      // la page avec ?customer_posted=true et la confirmation est déjà rendue
      // par Liquid. On rouvre pour la montrer, et on retient.
      //
      // Lu dans l'URL et non dans un attribut : form.posted_successfully?
      // n'existe qu'à l'intérieur du bloc form, pas sur la fenêtre qui
      // l'entoure. Ce marqueur est celui de Shopify, et ce formulaire est le
      // seul « customer » du thème.
      if (window.location.search.indexOf('customer_posted=true') !== -1) {
        remember();
        open();
        return;
      }

      // Ouverture automatique sur le panier, une seule fois par visiteur.
      if (dialog.dataset.newsletterAuto === 'true' && !alreadySeen()) {
        open(null, true);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
